// src/demo/email-frame.ts: a captured email in a sandboxed iframe (srcdoc, never the raw inner-HTML prop, lint rule
// 4), shared by the outbox page (OutboxScreen.tsx) and "See the Welcome Email" (DemoMail.tsx). The sandbox runs no
// scripts; links leave the frame for the top window, and only from a click.

export const EMAIL_SANDBOX = "allow-popups allow-top-navigation-by-user-activation";

/** The email with links aimed at the top window (the app refuses to be framed, so they must leave the frame). */
export function emailDocument(html: string): string {
  const base = '<base target="_top">';
  if (/<head[^>]*>/i.test(html)) return html.replace(/<head[^>]*>/i, (m) => m + base);
  return base + html;
}
